export default __webpack_public_path__ + "static/media/planB.e4587773.png";